<template>
  <div class="giftee-column-list-item">
    <a
      :href="`/announcements/${gifteeColumnId}`"
      class="giftee-column-list-item__link"
      @click="onClickColumn"
    >
      <ImgLazy
        :image-url="imageUrl"
        :alt-text="title"
        aspect-ratio="40 / 21"
        :width="204"
        :height="107"
        class="giftee-column-list-item__image"
      />
      <p class="giftee-column-list-item__title">{{ title }}</p>
    </a>
  </div>
</template>
<script>
import ImgLazy from '../../../../atoms/images/ImgLazy.vue'
export default {
  components: {
    ImgLazy
  },
  props: {
    gifteeColumnId: {
      type: Number,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickColumn() {
      dataLayer.push({
        event: 'click_top__column',
        announcement_id: this.gifteeColumnId
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.giftee-column-list-item {
  width: 204px;
  min-width: 204px;
  cursor: pointer;
  overflow: hidden;

  &:not(:last-child) {
    margin-right: 8px;
  }

  &__link {
    display: block;
    width: 100%;
    height: 100%;
  }

  &__image {
    @extend %hover-common;
    object-fit: cover;
    object-position: 0% 0%;
    border-radius: 10px;
  }

  &__title {
    @extend %module-text;
    margin-top: 4px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
